<template>
  <div class="alert-num">
    <div class="title">
      区域内视频报警总数
      <img src="@/assets/img/eduBigData/time-bg.png" alt="" />
    </div>
    <div class="num">
      <div v-for="(item, index) in numArray" :key="index">
        <span>{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "theAlertNum",
  components: {},
  props: {
    num: Number,
    msg: String,
  },
  data() {
    return {
      numArray: [],
    };
  },
  created() {},
  mounted() {
    this.modify();
  },
  computed: {},
  watch: {
    num: function (val) {
      this.modify();
    },
  },
  methods: {
    modify() {
      // console.log(this.num);
      let num = this.num;
      // num = 1152;
      // 最大显示六位数
      if (num > 999999) {
        num = 999999;
      }
      let numString = num.toString();
      // console.log(numString.length, "---------length");
      switch (numString.length) {
        case 1:
          numString = "00000" + numString;
          break;
        case 2:
          numString = "0000" + numString;
          break;
        case 3:
          numString = "000" + numString;
          break;
        case 4:
          numString = "00" + numString;
          break;
        case 5:
          numString = "0" + numString;
          break;
        default:
          break;
      }
      let numArray = numString.split("");
      // console.log(numArray)
      numArray.forEach((element, index) => {
        numArray[index] = parseInt(element);
      });
      this.numArray = numArray;
      // console.log(this.numArray)
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.alert-num {
  padding-top: 29px;
  padding-left: 25px;
  .title {
    width: 192px;
    height: 36px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #c4f0ff;
    line-height: 25px;
    text-align: center;
    line-height: 36px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .num {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 46px;
      height: 44px;
      box-shadow: 0px 0px 17px 0px rgba(17, 165, 215, 0.58) inset;
      font-size: 22px;
      font-family: Impact;
      color: #c4f0ff;
      line-height: 27px;
      text-shadow: 0px 2px 11px rgba(89, 233, 255, 0.6);
    }
  }
}
</style>